import { QueryString } from "./query-string";
import { inject, injectable } from "tsyringe";
import { Transform } from "tsyringe/dist/typings/types";
import { WINDOW } from "@identity/symbols";

export class LoggerTransformer implements Transform<Logger, Logger> {
  public transform(logger: Logger, loggerGroup: string) {
    return logger.setLoggerGroup(loggerGroup);
  }
}

@injectable()
export class Logger {
  logGroup = "Global";
  private debugGroup = this.getDebugGroup() || "";
  private groups = this.debugGroup.split(",");
  private initTime;

  constructor(@inject(WINDOW) window: Window) {
    this.initTime = window?.performance?.timeOrigin ?? Date.now();
  }

  setLoggerGroup(loggerGroup: string): this {
    this.logGroup = loggerGroup;
    return this;
  }

  getTimeDelta(): number {
    const currentTimeStamp = Date.now();

    return currentTimeStamp - this.initTime;
  }

  private getDebugGroup(): string {
    return QueryString.get("identity_debug");
  }

  private getTimeDeltaFixed(): string {
    const delta = this.getTimeDelta();
    const secondsResult = delta / 1000;

    return secondsResult.toFixed(4);
  }

  info(...logValues: any[]): void {
    if (this.loggingEnabled()) {
      console.info(
        `${this.getTimeDeltaFixed()}s\t\t [IE] ${this.logGroup}`,
        logValues
      );
    }
  }

  warn(...logValues: any[]): void {
    if (this.loggingEnabled()) {
      console.warn(
        `${this.getTimeDeltaFixed()}s\t\t [IE] ${this.logGroup}`,
        logValues
      );
    }
  }

  error(...logValues: any[]): void {
    if (this.loggingEnabled()) {
      console.error(
        `${this.getTimeDeltaFixed()}s\t\t [IE] ${this.logGroup}`,
        logValues
      );
    }
  }

  private loggingEnabled(): boolean {
    if (this.debugGroup === "") {
      return false;
    }

    return this.debugGroup === "1" || this.groups.indexOf(this.logGroup) !== -1;
  }
}
